export default "__VITE_ASSET__61b24ba2__"